import { useParams } from "react-router-dom";
import { Flex, Tabs, TabList, TabPanels, TabPanel } from "@chakra-ui/react";
import ProductProvider from "./ProductProvider";
import ProductDetails from "./components/ProductDetails";
import ProductSellingPrice from "./components/ProductSellingPrice";

const Product = () => {
  const { id } = useParams();

  return (
    <>
      <Flex padding={3} justify={'space-between'} width={"95%"} wrap={"wrap"}>
        <ProductDetails productId={id} />
        <ProductSellingPrice productId = {id} />
      </Flex>

      <Tabs>
        <TabList>
        </TabList>

        <TabPanels>
          <TabPanel>
            <ProductProvider productId={id as string} />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </>
  )
}


export default Product;